import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/sample-hardening';
import {default as Config} from '../../config'
import { TopMonths } from './TopMonths'
import { default as Calendar } from './Calendar'
import moment from 'moment';

export class List extends React.Component {

  constructor(props) {
		super(props);
		this.state = {isLoading: true};
	}

  componentWillMount () {
		this.props.actions.fetchSampleHardenings().then(function(response){
      this.setState({isLoading: false});
		}.bind(this));
	}

  componentWillReceiveProps(nextProps) {
    if(nextProps.location.query.month != undefined && nextProps.location.query.month != this.props.location.query.month){
      this.setState({isLoading: true});
      this.props.actions.fetchSampleHardenings(nextProps.location.query.month, false).then(function(response){
        this.setState({isLoading: false});
  		}.bind(this));
    }
  }

	render () {
    let today = new Date()
    return(
      <div>
      <h2>Lista próbek hartu</h2>
      <TopMonths active={this.props.routing.locationBeforeTransitions.query.month != undefined ? parseInt(this.props.routing.locationBeforeTransitions.query.month) : today.getMonth()+1} />
      {
        this.state.isLoading == false ?
          <Calendar samples={this.props.samples} calendarDate={moment('2018-'+(this.props.location.query.month != undefined ? this.props.location.query.month : '01')+'-01')} />
        :
        <div className="loading-content"></div>
      }
    </div>);
	}
}

const mapStateToProps = (state) => ({
  samples: state.sampleHardening.models,
  routing: state.routing
});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(List);



/** WEBPACK FOOTER **
 ** ./js/views/sample_hardening/List.js
 **/